/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  ActionLogDTO,
  Address,
  AddressInfoDTO,
  AddressJudgmentResult,
  AddressVerifyRequest,
  AddressVerifyResponse,
  AiCargoDTO,
  AiResultResponse,
  AllocateDTO,
  AllocateRequest,
  BatchAllocateRequest,
  BizOperRequest,
  BizOperResponse,
  CancelShipmentRequest,
  CarParamConfigDTO,
  CarrierCountDTO,
  CarrierCountResponse,
  CityDTO,
  CommissionAuditRequest,
  CompanyAddRequest,
  CompanyAuditRequest,
  CompanyDetailResponse,
  CompanyEditRequest,
  CompanyPageResponse,
  CompanyQueryRequest,
  CompanyStatusRequest,
  CreditEditRequest,
  CustomPlatformConfigPageResponse,
  CustomPlatformConfigQueryRequest,
  CustomPlatformConfigRequest,
  CustomPlatformConfigResponse,
  CustomerCreditResponse,
  CustomerFtlQuoteConfigDTO,
  CustomerQuoteConfigDTO,
  CustomerQuoteInfoDTO,
  CustomerQuoteInfoDetailDTO,
  CustomerQuoteServiceDetailDTO,
  CustomerResponse,
  DriverAddRequest,
  DriverDetailResponse,
  DriverInfoDTO,
  DriverPageResponse,
  DriverQueryRequest,
  DriverStatusRequest,
  ExceptionDealDetailResponse,
  ExceptionDealRequest,
  ExceptionDetailResponse,
  ExceptionPageResponse,
  ExceptionQueryRequest,
  FCashOutApproveRequest,
  FCashOutListResponse,
  FCashOutQueryRequest,
  FCashOutResponse,
  FCustomerWalletRequest,
  FCustomerWalletResponse,
  FHistoryBillRequest,
  FRechargeApproveRequest,
  FRechargeListResponse,
  FRechargeQueryRequest,
  FRechargeRequest,
  FRechargeResponse,
  FTradeRequest,
  FTransactionResponse,
  FWalletResponse,
  FmcsaCarrier,
  FmcsaCarrierListVO,
  FmcsaQueryRequest,
  FmcsaReamrkResponse,
  FmcsaStatusRequest,
  FreightClassRequest,
  FtlAcceptRequest,
  FtlAddStopRequest,
  FtlAddressIdDTO,
  FtlAddressResponse,
  FtlAmountDTO,
  FtlCargoDTO,
  FtlExactAddressDTO,
  FtlExactQuoteRequest,
  FtlOrderAmountRequest,
  FtlOrderAmountResponse,
  FtlOrderBackRequest,
  FtlOrderBatchIdRequest,
  FtlOrderCreateRequest,
  FtlOrderDetailExtResponse,
  FtlOrderDriverUpdateRequest,
  FtlOrderListExtResponse,
  FtlOrderPickDateRequest,
  FtlOrderPriceUpdateRequest,
  FtlOrderQueryRequest,
  FtlOrderRefNumberUpdateRequest,
  FtlOrderRemarkUpdateRequest,
  FtlQuoteConfigDTO,
  FtlQuoteConfigPageResponse,
  FtlQuoteConfigQueryRequest,
  FtlQuoteConfigRequest,
  FtlQuoteConfigResponse,
  FtlQuoteInfoDTO,
  FtlQuoteInfoDetailDTO,
  FtlQuoteResponse,
  FtlQuoteResultDTO,
  FtlRearrangeRequest,
  FtlStopFeeInfoDTO,
  FtlWaybillAllocateRequest,
  FtlWaybillAmountRecordDTO,
  FtlWaybillAmountUpdateRequest,
  FtlWaybillBolNoUpdateRequest,
  FtlWaybillDetailResponse,
  FtlWaybillListResponse,
  FtlWaybillPriceRequest,
  FtlWaybillPriceResponse,
  FtlWaybillRemarkUpdateRequest,
  FtlWaybillStatusRequest,
  FtlWaybillTrackLogResponse,
  FtlWaybillUpdateRequest,
  HelperInfoReqeust,
  IPage,
  LocalTime,
  LocalTimeReq,
  LocalTimeRes,
  MailQuoteConfigResponse,
  MainQuoteConfigPageResponse,
  MainQuoteConfigQueryRequest,
  MainQuoteConfigRequest,
  OrderAcceptRequest,
  OrderActionLogResponse,
  OrderAddressDTO,
  OrderAddressDTOReq,
  OrderAddressDTORes,
  OrderAmountRecordDTO,
  OrderAmountRequest,
  OrderAmountResponse,
  OrderBatchIdRequest,
  OrderBidPriceRequest,
  OrderBillToVo,
  OrderCargoDTO,
  OrderCountDTO,
  OrderCountResponse,
  OrderDetailResponse,
  OrderFileRequest,
  OrderListExtResponse,
  OrderPickDateRequest,
  OrderPickupInfoRequest,
  OrderPriceUpdateRequest,
  OrderQueryRequest,
  OrderQuoteDTO,
  OrderQuoteRequest,
  OrderQuoteResultResponse,
  OrderRefNumberUpdateRequest,
  OrderRequest,
  OrderSimpleCargoDTO,
  OrderSimpleInfoDTO,
  OrderTrackingDTO,
  OssFileResponse,
  OwnerQueryRequest,
  OwnerUserAuditRequest,
  OwnerUserEditRequest,
  OwnerUserPwdRequest,
  OwnerUserRequest,
  OwnerUserResponse,
  PageQuery,
  PlaceDetailResponse,
  PlaceResultDTO,
  PlaceResultResponse,
  PlaceSearchRequest,
  PlatformCommodityDTO,
  PlatformConfigDetailDTO,
  PlatformOrderCoreRequest,
  PlatformQuoteRateDTO,
  PlatformRateDetailDTO,
  QueryCityPageDTO,
  QueryQuoteAmountDTO,
  QuoteConfigDTO,
  QuoteConfigUpdateDTO,
  QuoteConfigUpdateRequest,
  QuoteInfoDTO,
  QuoteInfoDetailDTO,
  QuoteOrderPriceDTO,
  QuoteResultResponse,
  QuoteServiceDetailDTO,
  RouteDetailResponse,
  R,
  SalesAmountReportResponse,
  SalesCustomerRequest,
  SalesCustomerResponse,
  SalesDetailResponse,
  SalesOrderCountRequest,
  SalesOrderRequest,
  SalesOrderResponse,
  SalesQueryRequest,
  SalesSimpleResponse,
  SalesUserRequest,
  SalesUserResponse,
  SalesUserStatusVo,
  ServiceQuoteConfigRequest,
  ServiceQuoteConfigResponse,
  ServiceQuoteConfigUpdateRequest,
  ServiceQuoteDetailDTOReq,
  ServiceQuoteDetailDTORes,
  ShipmentCountResponse,
  ShipmentDetailExtResponse,
  ShipmentPageExtResponse,
  ShipmentQueryRequest,
  ShipmentTrackResponse,
  SimpleDriverListResponse,
  SimpleDriverQueryRequest,
  SimpleTruckListResponse,
  SimpleTruckQueryRequest,
  SysDepartmentTreeVo,
  SysDepartmentVo,
  SysPermission,
  SysPermissionTreeVo,
  SysPermissionVo,
  SysRoleResultVo,
  SysRoleVo,
  SysUserPasswordVo,
  SysUserQueryVo,
  SysUserStatusVo,
  SysUserVo,
  TimeZoneDTO,
  TrackInfo,
  TrackQueryRequest,
  TransferCenterQueryRequest,
  TransferCenterRequest,
  TransferCenterResponse,
  TranslateRequest,
  TranslateResponse,
  TruckAddOrEditRequest,
  TruckBindRequest,
  TruckDetailResponse,
  TruckPageQueryRequest,
  TruckPageResponse,
  TruckStatusRequest,
  UpdateBatchIdDTO,
  UpdateQuoteConfigDisableDTO,
  UserInfoVo,
  UserLoginVo,
  WaybillActionLogFileResponse,
  WaybillActionLogResponse,
  WaybillBolNoUpdateRequest,
  WaybillCountDTO,
  WaybillCountResponse,
  WaybillDetailResponse,
  WaybillFileResponse,
  WaybillPriceRecordDTO,
  WaybillPriceRequest,
  WaybillPriceResponse,
  WaybillPriceUpdateRequest,
  WaybillQueryRequest,
  WaybillRemarkUpdateRequest,
  WaybillRouteInfoDTO,
  WaybillRouteResponse,
  WaybillTrackLogResponse,
  WaybillTruckUpdateRequest,
  WaybillUpdateDriverRequest,
  WaybillUpdateRequest,
  WnChannelCommissionDTO,
} from './type';
import request from '@/utils/request';

export class CustomerService {
  // 新增
  public static addCustomerUsingPOST(userRequest: OwnerUserRequest): Promise<R<string>> {
    return request('POST', '/customer/add', null, null, userRequest, null, null);
  }

  // 客户审批
  public static auditUsingPUT(auditRequest: OwnerUserAuditRequest): Promise<R<string>> {
    return request('PUT', '/customer/audit', null, null, auditRequest, null, null);
  }

  // 关闭信用额度
  public static creditClosedUsingPUT(cusId: number): Promise<R<string>> {
    return request('PUT', '/customer/credit-closed', null, { cusId }, null, null, null);
  }

  // 新增或更新信用额度
  public static creditEditUsingPOST(creditRequest: CreditEditRequest): Promise<R<string>> {
    return request('POST', '/customer/credit-edit', null, null, creditRequest, null, null);
  }

  // 信用额度详情
  public static creditInfoUsingGET(cusId: number): Promise<R<CustomerCreditResponse>> {
    return request('GET', '/customer/credit-info', null, { cusId }, null, null, null);
  }

  // 修改保存客户
  public static editCustomerUsingPOST(userRequest: OwnerUserEditRequest): Promise<R<string>> {
    return request('POST', '/customer/edit', null, null, userRequest, null, null);
  }

  // 订单导出
  public static exportCustomerUsingPOST(query: OwnerQueryRequest): Promise<void> {
    return request('POST', '/customer/export', null, null, query, null, null);
  }

  // 整车配置分页查询
  public static pageCusFltConfigUsingPOST(
    queryDTO: FtlQuoteConfigQueryRequest,
  ): Promise<R<IPage<FtlQuoteConfigPageResponse>>> {
    return request('POST', '/customer/ftlConfigPage', null, null, queryDTO, null, null);
  }

  // 整车配置查看详情
  public static detailCusFltQuoteConfigUsingGET(cusId: number, id: number): Promise<R<FtlQuoteConfigResponse>> {
    return request('GET', '/customer/ftlQuoteConfigDetail', null, { cusId, id }, null, null, null);
  }

  // 分页查询
  public static pageCustomerUsingPOST(query: OwnerQueryRequest): Promise<R<IPage<OwnerUserResponse>>> {
    return request('POST', '/customer/list', null, null, query, null, null);
  }

  // 查看客户配置详情
  public static quoteConfigDetailUsingGET(cusId: number, id: number): Promise<R<CustomerQuoteConfigDTO>> {
    return request('GET', '/customer/quoteConfigDetail', null, { cusId, id }, null, null, null);
  }

  // 客户报价配置分页查询
  public static quoteConfigPageUsingGET(
    carType?: number,
    cityCode?: string,
    countryCode?: string,
    countryName?: string,
    distance?: number,
    isAsc?: boolean,
    ownerId?: number,
    pageNo?: number,
    pageSize?: number,
    quoteType?: number,
    searchText?: string,
    sortBy?: string,
  ): Promise<R<IPage<QuoteConfigDTO>>> {
    return request(
      'GET',
      '/customer/quoteConfigPage',
      null,
      {
        carType,
        cityCode,
        countryCode,
        countryName,
        distance,
        isAsc,
        ownerId,
        pageNo,
        pageSize,
        quoteType,
        searchText,
        sortBy,
      },
      null,
      null,
      null,
    );
  }

  // 修改客户登陆账号密码
  public static resetPwdUsingPOST(userRequest: OwnerUserPwdRequest): Promise<R<string>> {
    return request('POST', '/customer/resetPwd', null, null, userRequest, null, null);
  }

  // 简单列表查询-查询条件使用
  public static listCustomerUsingPOST(query: OwnerQueryRequest): Promise<R<IPage<CustomerResponse>>> {
    return request('POST', '/customer/simpleList', null, null, query, null, null);
  }

  // 更新自营报价配置-整车
  public static updateCusFtlQuoteConfigUsingPOST(quoteConfigDTO: CustomerFtlQuoteConfigDTO): Promise<R<boolean>> {
    return request('POST', '/customer/updateFtlQuoteConfig', null, null, quoteConfigDTO, null, null);
  }

  // 更新自营报价配置-同城
  public static updateCusQuoteConfigUsingPOST(quoteConfigDTO: CustomerQuoteConfigDTO): Promise<R<boolean>> {
    return request('POST', '/customer/updateQuoteConfig', null, null, quoteConfigDTO, null, null);
  }

  // 客户禁用启用
  public static updateCustomerVisibleUsingPUT(statusVo: SysUserStatusVo): Promise<R<string>> {
    return request('PUT', '/customer/updateStatus', null, null, statusVo, null, null);
  }
}
